import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import RwdPicture from "@components/RwdPicture";
import ViewportRoot from "@ts/sframe/ViewportRoot";
import Tools from "@ts/Tools";
import { gsap } from "gsap";

export default class ImageSlider extends ComponentBase {
  LOOP_TIMEOUT: number = 5.5;
  $wrapper: JQuery;
  timer: gsap.core.Timeline;
  currentIndex: number = 0;
  numImages: number;
  isLocking: boolean = false;
  picList: HTMLElement[];
  picSize =
    {
      pc: {
        width: 100,
        height: 100
      },
      mobile: {
        width: 100,
        height: 100
      }
    }

  constructor(elem: ComponentElem) {
    super(elem);

    let rwdSize = this.$root[0].dataset.imageSize;
    this.picSize = getImageSize(rwdSize);

    let $wrapper = this.$wrapper = this.$root.find(".wrapper"),
      picList = this.picList = $wrapper.find(".pic").toArray();

    // 只有一張圖的話, 重製一次
    if (picList.length === 1) {
      let $nextPic = $(picList[0]).clone();
      $wrapper.append($nextPic);
      new RwdPicture($nextPic.find(`picture`)[0] as ComponentElem);
      picList.push($nextPic[0]);
    }

    // 只有兩張圖的話, 重製一次
    if (picList.length === 2) {
      let $nextPic = $(picList[0]).clone();
      $wrapper.append($nextPic);
      new RwdPicture($nextPic.find(`picture`)[0] as ComponentElem);
      picList.push($nextPic[0]);
    }

    this.numImages = picList.length;

    // 重製 1,2 張到尾部, 和最後 1,2 張到最前面
    let $firstPic = $(picList[0]).clone(),
      $secondPic = $(picList[1]).clone(),
      $finalPic = $(picList[picList.length - 1]).clone(),
      $lastTwoPic = $(picList[picList.length - 2]).clone();

    picList.push($firstPic[0]);
    $wrapper.append($firstPic);
    picList.push($secondPic[0]);
    $wrapper.append($secondPic);

    picList.unshift($finalPic[0]);
    $wrapper.prepend($finalPic);
    picList.unshift($lastTwoPic[0]);
    $wrapper.prepend($lastTwoPic);

    new RwdPicture($firstPic.find(`picture`)[0] as ComponentElem);
    new RwdPicture($secondPic.find(`picture`)[0] as ComponentElem);
    new RwdPicture($finalPic.find(`picture`)[0] as ComponentElem);
    new RwdPicture($lastTwoPic.find(`picture`)[0] as ComponentElem);


    if (this.$root[0].getAttribute("autoplay") === "true") {
      this.timer = gsap.timeline({ repeat: -1, paused: true });
      this.timer.add(() => {
        this.toNext();
      }, this.LOOP_TIMEOUT);
    }

    ViewportRoot.emitter.addListener("updated", () => {
      this.update(true);
    });

    let necessaryCount = 3,
      completeCount = 0;

    picList.forEach((elem, index) => {
      let $pic = $(elem),
        rwdPicture = ($pic.find(`[component="rwd-picture"]`)[0] as ComponentElem)._component;

      $pic.attr(`rwd-size`, rwdSize);

      if (index >= 1 && index <= necessaryCount) {
        rwdPicture.load(() => {
          completeCount++;
          if (completeCount === necessaryCount) {
            this.start();
          }
        });
      }
      else {
        rwdPicture.load();
      }
    });
  }

  start() {
    this.update(true);
    this.$root.attr("is-ready", "true");
  }

  toPrev() {
    if (this.isLocking) return;

    let self = this,
      index = this.currentIndex - 1;

    execute();

    function execute() {
      self.currentIndex = index;
      self.update(false, (index < 0) ? "final" : null);
    }
  }

  toNext() {
    if (this.isLocking) return;

    let self = this,
      index = this.currentIndex + 1;

    execute();

    function execute() {
      self.currentIndex = index;
      self.update(false, (index >= self.numImages) ? "first" : null);
    }
  }

  update(instantPlay: boolean = false, resetTo?: "first" | "final") {
    let currentPicElem = this.picList[this.currentIndex + 2],
      targetLeft = -currentPicElem.offsetLeft + (this.$root[0].clientWidth * .5) - (currentPicElem.clientWidth * .5);

    this.isLocking = true;

    if (this.timer) this.timer.pause();

    let duration = instantPlay ? 0 : 2.5;

    let tl = gsap.timeline();
    tl.to(this.$wrapper, { duration: duration, left: targetLeft, ease: "power4.inOut" });
    tl.add(() => {
      if (resetTo === "first") {
        this.currentIndex = 0;

        let elem = this.picList[this.currentIndex + 2],
          targetLeft = -elem.offsetLeft + (this.$root[0].clientWidth * .5) - (elem.clientWidth * .5);
        gsap.set(this.$wrapper, { left: targetLeft });
      }
      else if (resetTo === "final") {
        this.currentIndex = this.numImages - 1;

        let elem = this.picList[this.currentIndex + 2],
          targetLeft = -elem.offsetLeft + (this.$root[0].clientWidth * .5) - (elem.clientWidth * .5);
        gsap.set(this.$wrapper, { left: targetLeft });
      }

      if (this.timer) this.timer.restart();

      this.isLocking = false;
    });
  }
}

function getImageSize(string: string) {
  try {
    let array = string.split(`|`),
      pcArray = array[0].split(`x`),
      mobileArray = array[1].split(`x`);
    let result =
    {
      pc: {
        width: parseInt(pcArray[0]),
        height: parseInt(pcArray[1])
      },

      mobile: {
        width: parseInt(mobileArray[0]),
        height: parseInt(mobileArray[1])
      }
    };

    Tools.addCustomStyle(`[rwd-size="${string}"]`, `width: ${result.pc.width}px; height: ${result.pc.height}px;`);
    Tools.addCustomStyle(`[rwd-size="${string}"]`, `width: ${result.mobile.width}px; height: ${result.mobile.height}px;`, true);

    return result;
  }
  catch (e) {
    throw new Error(`illegal data-image-size: [${string}]`);
  }


}